import React from 'react';
import { MagnifyingGlassIcon, BellIcon, Bars3Icon, Cog6ToothIcon, ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';

export default function Topbar({ onMenuClick, onSettings, onLogout }) {
  return (
    <header className="bg-white border-b flex items-center justify-between px-6 h-16">
      <div className="flex items-center gap-3">
        <button
          className="p-2 rounded-md hover:bg-gray-100"
          onClick={onMenuClick}
          aria-label="Toggle sidebar"
        >
          <Bars3Icon className="h-6 w-6 text-gray-700" />
        </button>

        <div className="flex items-center bg-gray-100 border rounded-lg px-3 py-2">
          <input
            type="text"
            placeholder="Search ..."
            className="w-48 md:w-56 ml-2 bg-gray-100 border-none outline-none"
          />
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-500 flex-shrink-0" />
          
        </div>

        
        
      </div>

      <div className="flex items-center gap-3">
        <button
          className="relative p-2 rounded-full hover:bg-gray-100"
          aria-label="Notifications"
        >
          <BellIcon className="h-6 w-6 text-gray-700" />
          <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500" />
        </button>

        <button
          onClick={onSettings}
          className="p-2 rounded-full hover:bg-gray-100"
          aria-label="Settings"
        >
          <Cog6ToothIcon className="h-6 w-6 text-gray-700" />
        </button>

        <button
          className="flex items-center p-2 rounded-full hover:bg-gray-100"
          aria-label="Profile"
        >
          <img
            src="https://via.placeholder.com/32"
            alt="profile"
            className="h-8 w-8 rounded-full"
          />
        </button>

        <button
          onClick={onLogout}
          className="p-2 rounded-full hover:bg-gray-100"
          aria-label="Logout"
        >
          <ArrowLeftOnRectangleIcon className="h-6 w-6 text-gray-700" />
        </button>
      </div>
    </header>
  );
}
